/** @jsx jsx */
import url from 'url';

import { Dialog } from '@datacamp/waffles/dialog';
import { Heading } from '@datacamp/waffles/heading';
import { Paragraph } from '@datacamp/waffles/paragraph';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useSelector } from '../../interfaces/State';
import * as selectors from '../../redux/selectors';

import AppleBadge from './AppleBadge';
import GooglePlayBadge from './GooglePlayBadge';

const linkStyle = {
  display: 'inline-flex',
  textDecoration: 'none',
  borderRadius: tokens.borderRadius.medium,
  border: 0,
  margin: 0,
  padding: 0,
  position: 'relative',
  ':after': {
    content: "''",
    display: 'block',
    position: 'absolute',
    zIndex: tokens.zIndex.default,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: -2,
    borderRadius: 6,
    pointerEvents: 'none',
    transition: 'box-shadow 125ms ease-out',
  },
  ':focus-visible:after': {
    boxShadow: `0 0 0 2px ${tokens.colors.blueDark}`,
  },
} as const;

const MobileAdModal: React.FC = () => {
  const { t } = useTranslation();
  const currentUrl = useSelector(selectors.selectCanonical);
  const STORE_URL = url.format({
    protocol: 'https',
    hostname: 'datacamp.onelink.me',
    pathname: '/xztQ/3twvtm0c',
    query: {
      deep_link_sub1: JSON.stringify({
        src_url: currentUrl,
      }),
    },
  });

  return (
    <>
      <Dialog.Header>{t('MobileAdModal.header')}</Dialog.Header>
      <Dialog.Body>
        <Paragraph>{t('MobileAdModal.text')}</Paragraph>
        <Heading size="large">{t('MobileAdModal.heading')}</Heading>
        <div
          css={{
            display: 'inline-flex',
            gap: tokens.spacing.medium,
            paddingBottom: tokens.spacing.medium,
          }}
        >
          <a
            aria-label={t('MobileAdModal.appStoreLabel')}
            data-cy="mobile-modal-apple-button"
            id="mobile-modal-apple-button"
            href={STORE_URL}
            css={linkStyle}
          >
            <AppleBadge />
          </a>
          <a
            aria-label={t('MobileAdModal.googlePlayLabel')}
            data-cy="mobile-modal-google-button"
            id="mobile-modal-google-button"
            href={STORE_URL}
            css={linkStyle}
          >
            <GooglePlayBadge />
          </a>
        </div>
      </Dialog.Body>
    </>
  );
};

export default MobileAdModal;
